import { render, staticRenderFns } from "./CompanyCourseDetails.vue?vue&type=template&id=2531e304&scoped=true"
import script from "./CompanyCourseDetails.vue?vue&type=script&lang=js"
export * from "./CompanyCourseDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyCourseDetails.vue?vue&type=style&index=0&id=2531e304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531e304",
  null
  
)

export default component.exports